import Image from '@components/Image'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
import { MapContainer, TileLayer, useMap, ZoomControl } from 'react-leaflet'
import { GoogleMap, LoadScriptNext, Marker } from '@react-google-maps/api'
import { Marker as MarkerLeaflet } from 'react-leaflet'
import L from 'leaflet'
import Icon from './map-icon.png'
import { ElementHTML, HTMLContentElement } from '@helpers/helper.rendering'

interface Coordinate {
  lat: number
  lng: number
}

const Contact_2 = (props: RealEstateDataPageComponentData) => {
  const { items, global_data, coordinates, titleElement, subtitleElement, paragraphElement, zoom } =
    props
  const icons = global_data.pageConfig.design.icons

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const GOOGLE_KEY = global_data.pageConfig.keys.map

  const branchItem = (title: string, icon: string, value: string) => (
    <Col
      lg={2}
      xs={12}
      className="d-flex align-items-start mt-3"
    >
      <i
        className={`icon-${icon}${iconsStyle}`}
        style={{ fontSize: '24px' }}
      />
      <div className="ms-3 pb-4 pb-lg-0">
        <HTMLContentElement
          htmlContent={`<strong>${title}</strong>`}
          elementType={subtitleElement ?? 'h5'}
        />
        {icon == 'email' ? (
          <a
            className="emailto"
            href={'mailto:' + value}
          >
            {value}
          </a>
        ) : (
          <ElementHTML
            children={value ?? ''}
            elementType={paragraphElement ?? 'p'}
          />
        )}
      </div>
    </Col>
  )

  const myIcon = L.icon({
    iconUrl: Icon,
    iconSize: [27, 41],
    iconAnchor: [12.5, 41],
    popupAnchor: [0, -41],
    shadowSize: [41, 41],
    shadowAnchor: [12.5, 41],
  })

  const calculateBounds = (coords: Coordinate[]) => {
    const bounds = new L.LatLngBounds(coords.map((coord) => [coord.lat, coord.lng]))
    return bounds.pad(0.05)
  }

  const SetViewOnBounds = ({ bounds, zoom }: { bounds: L.LatLngBounds; zoom: number }) => {
    const map = useMap()
    map.fitBounds(bounds)
    map.setZoom(zoom)
    return null
  }

  const calculateGoogleMapCenter = (coords: Coordinate[]) => ({
    lat: coords.reduce((sum, coord) => sum + coord.lat, 0) / coords.length,
    lng: coords.reduce((sum, coord) => sum + coord.lng, 0) / coords.length,
  })

  const handleGoogleMapLoad = (map: google.maps.Map) => {
    const center = calculateGoogleMapCenter(coordinates ?? [{ lat: -34.6037, lng: -58.3816 }])

    map.setCenter(center)
    map.setZoom(Number(zoom) ?? 13)
  }

  return (
    isMounted && (
      <section className="contact-2 bg-white p-y-config">
        <Container
          fluid
          className="px-0 px-lg-5"
        >
          {items?.map((item, index) => (
            <div
              className="mb-5 branch-container"
              key={index}
            >
              <ElementHTML
                children={item.title ?? ''}
                elementType={titleElement ?? 'h3'}
              />
              <div
                style={{
                  height: '1px',
                  backgroundColor: '#C1C1C1',
                }}
                className="my-2"
              />
              <Row className="d-flex justify-content-between mt-3">
                {branchItem('Teléfono', 'phone', item.phone ?? '')}
                {branchItem('WhatsApp', 'whatsapp', item.whatsapp ?? '')}
                {branchItem('Correo electrónico', 'email', item.email ?? '')}
                {branchItem('Dirección', 'location', item.address ?? '')}
                <Col
                  lg={2}
                  xs={12}
                  className="mt-3 text-center d-none d-lg-block"
                >
                  <Image
                    className="no-border"
                    objectFit="contain"
                    alt="qr-img"
                    image={item.image_gatsby!}
                    style={{ maxWidth: '100px', height: 'auto' }}
                  />
                  <HTMLContentElement
                    htmlContent={`<strong>${item.paragraph}</strong>`}
                    elementType={subtitleElement ?? 'h5'}
                    className="mt-2"
                  />
                </Col>
              </Row>
            </div>
          ))}
          <Row className="branch-container px-0 mt-0 mt-lg-5 pt-0 pt-lg-5 d-block">
            {!GOOGLE_KEY ? (
              <MapContainer
                scrollWheelZoom={false}
                zoomControl={false}
                dragging={!L.Browser.mobile}
                style={{ height: '50vh', position: 'relative' }}
              >
                <TileLayer url="https://api.maptiler.com/maps/dataviz/256/{z}/{x}/{y}.png?key=fzW9HzAb6C93tDpePOno" />
                <ZoomControl position="bottomright" />
                <SetViewOnBounds
                  bounds={calculateBounds(coordinates ?? [{ lat: -34.6037, lng: -58.3816 }])}
                  zoom={zoom ?? 13}
                />
                {coordinates?.map((coord, index) => (
                  <MarkerLeaflet
                    key={`leaflet-marker-${index}`}
                    position={coord}
                    icon={myIcon}
                  />
                ))}
              </MapContainer>
            ) : (
              <LoadScriptNext
                googleMapsApiKey={GOOGLE_KEY}
                libraries={['places', 'marker']}
                language="es-AR"
              >
                <GoogleMap
                  onLoad={handleGoogleMapLoad}
                  mapContainerStyle={{
                    width: '100%',
                    height: '50vh',
                  }}
                >
                  {coordinates?.map((coord, index) => (
                    <Marker
                      key={`google-marker-${index}`}
                      position={coord}
                    />
                  ))}
                </GoogleMap>
              </LoadScriptNext>
            )}
          </Row>
        </Container>
      </section>
    )
  )
}

export default Contact_2
